import { StyleSheet } from 'react-native';
import { colors, fontSizes, borderRadius } from '../../global-styles/globalStyles';

const styles = StyleSheet.create({
  // view styles
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textInput: {
    width: 52,
    textAlign: 'center',
    padding: 4,
    borderWidth: 1,
    borderRadius,
    borderColor: colors.mediumGrey,
  },
  button: {
    minWidth: 110,
    marginHorizontal: 6,
  },
  thresholdContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 12,
    paddingVertical: 2,
    paddingHorizontal: 12,
    backgroundColor: colors.white,
  },
  marginX: {
    marginHorizontal: 4,
  },
  separator: {
    borderBottomWidth: 0,
    marginVertical: 8,
  },

  // text styles
  header: {
    fontWeight: '600',
    fontSize: fontSizes.medium,
  },
  nowrap: {
    // @ts-ignore
    whiteSpace: 'nowrap',
  },
  fontBold: {
    fontWeight: '600',
  },
  cancel: {
    color: colors.no,
  },
  confirm: {
    color: colors.yes,
  },
  link: {
    color: colors.linkBlue,
  },
});

export default styles;
